import ErrorBoundary from '@hrms/common/component/error-boundary';
import { Toast, Typography } from '@zeptonow/zui';
import React from 'react';
import { generateImage } from '../../utils/generateImage';
import {
  toastAlertClass,
  toastDescriptionClass,
  toastIconClass,
  toastMessageClass,
} from './constant';
import { ToastComponentProps } from './types';

const ToastComponent: React.FC<ToastComponentProps> = ({
  visibility,
  handleToastClose,
  severity,
  message,
  description,
  autoHideDuration = 2000,
}) => {
  if (!visibility || !severity) return null;

  return (
    <ErrorBoundary>
      <Toast
        isOpen={visibility}
        handleClose={handleToastClose}
        severity={severity}
        autoHideDuration={autoHideDuration}
        alertClassName={`${toastAlertClass[severity]} !border-[1.5px] !pb-3 !rounded-lg`}
        message={
          <Typography className={`${toastMessageClass[severity]} !text-base`}>
            {message}
          </Typography>
        }
        description={
          <Typography className={`${toastDescriptionClass[severity]} !text-sm`}>
            {description}
          </Typography>
        }
        icon={generateImage({
          noScale: true,
          name: `${severity}-icon`,
          alt: 'toast icon',
          className: '',
        })}
        action={
          <div
            className={`hover:cursor-pointer rounded-full ${toastIconClass[severity]}`}
            onClick={handleToastClose}
          >
            {generateImage({
              noScale: true,
              name: `${severity}-cross`,
              alt: 'cross icon',
              className: '!m-3 !p-0',
            })}
          </div>
        }
      />
    </ErrorBoundary>
  );
};

export default ToastComponent;
